import React from 'react'
import './style.scss'
import { CircularProgress, CardContent, Typography, Card, CardMedia } from '@mui/material'
import PropTypes from 'prop-types'
import { HeaderLoadingCard } from '../../header/HeaderLoadingCard'
import backgroundImage from '../../../assets/img/renewables.jpg'

export const SplashLoadingForm = ({ topMessage }) => {
  return (
    <div className="splashCard">
      <div className="content">
        <Card>
          <HeaderLoadingCard></HeaderLoadingCard>
          <CardContent className="card">
            <CardMedia component="img" height="200" image={backgroundImage} />
            <div className="indicator">
              <CircularProgress color="primary" size={25} />
            </div>
            <div className="top-content">
              <Typography variant="body2" className="text-info">
                {topMessage}
              </Typography>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

SplashLoadingForm.propTypes = {
  topMessage: PropTypes.string.isRequired
}

SplashLoadingForm.defaultProps = {
  topMessage: 'Information loading in process'
}
